import TableSelectionService from "external-services/table-selection-service/index";
import ObjectCopyService from "external-services/object-copy-service/index";
import BookingsAffectedService from "app/services/bookingsAffected/bookingsAffected.service";
import SectionLookupService from "external-services/section-lookup-service/sectionLookup.service";
import TablesLookupService from 'external-services/tables-lookup-service/tablesLookup.service';
import LayoutsService from 'external-services/layouts-service/layouts.service';
import GridSyncService from 'app/services/gridSync/gridSync.service';
import AdminService from 'external-services/diary-admin-service/admin.service';
import DateUtilsService from 'external-services/date-utils-service';
import PouchLoadService from "external-services/pouch-load-service";
import {WHOLE_NUMBER_REGEX} from "appRoot/app.constants";

const NS = 'LayoutEditCtrl'; // jshint ignore:line

export default function LayoutEditCtrl(
  $scope, $rootScope, $log, $state, $stateParams, $filter,
  $mdDialog, $mdToast, tablesService, scheduleService,
  unregister
) {
  "ngInject";

  var vm = this;

  var listeners = [];
  var orgTables;
  var savedLayout;
  var orgLayout;
  var deletedTables = [];
  var changedTables = [];
  const timezoneId = AdminService.getVenueTimezoneId();
  var date = DateUtilsService.getVenueTime(timezoneId);
  date.setDate(date.getDate());

  //-- define public properties
  vm.saveDate = DateUtilsService.dateToIdStr(date);
  vm.effectiveFromDate = date;
  vm.shapes = tablesService.shapes;
  vm.availableOptions = tablesService.availableOptions;
  vm.WHOLE_NUMBER_REGEX = WHOLE_NUMBER_REGEX;

  // states
  vm.LOADING = 1;
  vm.ENTER = 0;
  vm.SAVED = 2;
  vm.ERROR = 3;
  vm.CONFLICTS = 4;
  vm.state = vm.LOADING;
  //-- define public methods
  vm.save = save;
  vm.cancel = cancel;
  vm.tryAgain = tryAgain;
  vm.addTable = addTable;
  vm.deleteTable = deleteTable;
  vm.addTableJoin = addTableJoin;
  vm.deleteTableJoin = deleteTableJoin;
  vm.printConflicts = printConflicts;
  vm.undo = undo;
  vm.accept = accept;

  if ($stateParams.id) {
    getSectionsLookUp();
  } else {
    $state.go('settings.layouts');
  }

  listeners.push($scope.$on('$destroy', () => unregister(listeners)));

  function printConflicts() {
    window.print();
  }

  function getSectionsLookUp() {
    SectionLookupService.getSectionsLookUp().then(function (sections) {
      vm.sectionsLookup = sections;
      getLayout();
    }).catch(function (err) {
      $log.error('error getSectionsLookUp', err);
    });
  }

  function getLayout() {
    var id = decodeURIComponent($stateParams.id);
    LayoutsService.getLayoutById(id).then(function (layout) {
      orgLayout = ObjectCopyService.angularSafeCopy(layout);
      vm.layout = layout;
      var tablesJoins = (vm.layout.tablesJoins) ? vm.layout.tablesJoins : [];
      tablesService.checkTablesAvailableOptions(tablesJoins);
      vm.layout.tablesJoins = tablesJoins;
      getTables();
    }).catch(function (err) {
      $log.error('Failed to load layout', err);
    });
  }

  function getTables() {
    TablesLookupService.getAllTablesByIds(vm.layout.tables).then(function (tables) {
      tablesService.checkTablesAvailableOptions(tables);
      vm.tables = $filter('alphaSortFilter')(tables, 'name');
      vm.state = vm.ENTER;
      orgTables = ObjectCopyService.angularSafeCopy(vm.tables);
    }).catch(function (err) {
      $log.error('Failed to load tables', err);
    });
  }

  function deleteTable(evt, table) {
    var inJoins = [];

    for (var i = vm.layout.tablesJoins.length - 1; i >= 0; i--) {
      var tableJoin = vm.layout.tablesJoins[i];
      if (tableJoin && tableJoin.tables && tableJoin.tables.indexOf(table._id) !== -1) {
        // the table was found in the join
        inJoins.push(i);
      }
    }

    var message = 'Are you sure you would like to remove this table ' + table.name + '.';
    if (inJoins.length) {
      message += ' You will also be deleting ' + inJoins.length + ' join(s) that use this table.';
    }

    var confirm = $mdDialog.confirm()
      .parent(angular.element(document.body))
      .title('Remove table?')
      .htmlContent(message)
      .ariaLabel('Remove table')
      .ok('Yes')
      .cancel('No')
      .targetEvent(evt);
    $mdDialog.show(confirm).then(function () {
      table.markedForDelete = true;
      if (inJoins.length) {
        for (var i = 0; i < inJoins.length; i++) {
          vm.layout.tablesJoins.splice(inJoins[i], 1);
        }
      }
    });
  }

  function tryAgain() {
    vm.state = vm.ENTER;
  }

  function cancel() {
    $state.go('settings.layouts');
  }

  function addTable() {
    var lastTable = vm.tables[vm.tables.length - 1];
    vm.tables.push({
      markedToAdd: true,
      name: '',
      order: (lastTable) ? lastTable.order + 1 : 0,
      shared: false,
      capacity: 2,
      minCapacity: 1,
      online: true,
      walkinOnly: false,
      availableOption: 'all',
      type: 'table',
      sectionId: vm.layout.sectionId,
      _id: PouchLoadService.getNewId(['table'])
    });
  }

  function addTableJoin() {
    vm.layout.tablesJoins.push({
      online: true,
      walkinOnly: false,
      availableOption: 'all',
    });
  }

  function deleteTableJoin(evt, tableJoin, index) {
    var confirm = $mdDialog.confirm()
      .parent(angular.element(document.body))
      .title('Remove table join?')
      .content('Are you sure you would like to remove this table join')
      .ariaLabel('Remove table join')
      .ok('Yes')
      .cancel('No')
      .targetEvent(evt);
    $mdDialog.show(confirm).then(function () {
      vm.layout.tablesJoins.splice(index, 1);
    });
  }

  function save(evt, isValid) {
    if (isValid) {
      // show a confirm dialog
      var results = tablesService.getTableChanges(vm.tables, orgTables);
      if (!results.deletedTables.length && !results.changedTables.length) {
        doSave();
      } else {
        var timeNow = DateUtilsService.getVenueTime(timezoneId);
        // check for conflict
        BookingsAffectedService.checkLayout(results.deletedTables, results.changedTables, timeNow).then(function (bookingConflicts) {
          if (bookingConflicts.length) {
            // show a confirm dialog
            $mdDialog.show({
              controller: 'AffectedBookingsConfirmCtrl',
              controllerAs: 'vm',
              templateUrl: 'app/settings/confirmDialogs/affectedBookingsConfirm.html',
              parent: angular.element(document.body),
              targetEvent: evt,
              locals: {
                bookingConflicts: bookingConflicts
              },
              clickOutsideToClose: true
            })
              .then(function () {
                doSave(bookingConflicts);
              });
          } else {
            // no conflicts found
            doSave();
          }
        });
      }
    } else {
      vm.displayErrors = true;
    }
  }



  function doSave(bookingConflicts) {

    tablesService.updateLayout(new Date(), vm.layout, vm.tables, orgTables)
      .then(results => {
        if (bookingConflicts) {
          return TableSelectionService.addBookingsWithNoTablesToWaitList(bookingConflicts, results.deletedTables)
            .then(() => results);
        } else {
          return results;
        }
      })
      .then(function (results) {
        vm.state = vm.ENTER;
        // show saved toast
        $mdToast.show(
          $mdToast.simple()
            .content('Layout Saved')
            .position('bottom right')
            .theme('saved')
            .hideDelay(3000)
        );
        // results
        savedLayout = results.savedLayout;

        // CLI-165: notify the Grid Sync API of the edited layout
        if (savedLayout) {
          GridSyncService.layoutEdited(savedLayout._id);
        }
        deletedTables = results.deletedTables;
        changedTables = results.changedTables;
        // check to see if a conflict check is need
        if (!deletedTables.length && !changedTables.length) {
          $state.go('settings.layouts');
        } else {
          var timeNow = DateUtilsService.getVenueTime(timezoneId);
          // check for conflict
          BookingsAffectedService.checkLayout(deletedTables, changedTables, timeNow)
            .then(function (bookingConflicts) {
              if (bookingConflicts.length) {
                vm.state = vm.CONFLICTS;
                vm.bookingConflicts = bookingConflicts;
              } else {
                $state.go('settings.layouts');
              }
            });
        }
        listeners.push($rootScope.$on('booking-edited', reCheckConfict));
      })
      .then(() => {
        TablesLookupService.createTableLookup();
        // tablesService.createTableLookUp(); // refreshes the tablesLookUp which holds capacities)
      })
      .catch(function (err) {
        $log.error(err);
        vm.state = vm.ERROR;
      });
  }

  function reCheckConfict(booking) {
    BookingsAffectedService.checkLayout(deletedTables, changedTables, new Date(), booking).then(function (effectedBookings) {
      if (!effectedBookings || (effectedBookings.length === 0)) {
        // remove the effectted booking from the conflict list
        var bookingIds = vm.bookingConflicts.map(function (bookingItem) {
          return bookingItem._id;
        });
        var index = bookingIds.indexOf(booking._id);
        vm.bookingConflicts.splice(index, 1);
      }
    });
  }

  function undo() {
    LayoutsService.getLayoutById(savedLayout._id).then(function (layout) {
      orgLayout._rev = layout._rev;
      // update the schedule id.
      var idParts = orgLayout._id.split('_');
      var dateStr = idParts[idParts.length - 1];
      if (dateStr !== vm.saveDate) {
        delete orgLayout._rev;
        // we are going to save this as a new layout
        // so that the old was is kept for past bookings
        // so remove the revision
        idParts.pop();
        idParts.push(vm.saveDate);
        orgLayout._id = idParts.join('_');
      }
      return tablesService.updateLayout(orgLayout, []);
    })
      .then(function () {
        $mdToast.show(
          $mdToast.simple()
            .content('Layout reverted')
            .position('bottom right')
            .theme('saved')
            .hideDelay(3000)
        );
        $state.go('settings.layouts');
      })
      .catch(function (err) {
        $log.error(err);
        vm.state = vm.ERROR;
      });
  }

  function accept() {
    $state.go('settings.layouts');
  }
}
